var _rect, _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEngardeLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 5.67143,
    fill: "#252525",
    stroke: "#252525"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5292 17.475H15.9992C15.4138 17.475 14.9392 17.9496 14.9392 18.535V21.465C14.9392 22.0504 15.4138 22.525 15.9992 22.525H26.5292C27.1146 22.525 27.5892 22.0504 27.5892 21.465V18.535C27.5892 17.9496 27.1146 17.475 26.5292 17.475Z",
    fill: "url(#g)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5192 8.08502C10.8492 8.08502 10.4792 8.86502 10.8992 9.39502L12.7292 11.675C13.4692 12.595 14.5892 13.135 15.7792 13.135H29.7192C30.2992 13.135 30.7792 12.665 30.7792 12.075V9.14502C30.7792 8.56502 30.3092 8.08502 29.7192 8.08502H11.5192Z",
    fill: "url(#g)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7092 26.865H15.7692C14.5792 26.865 13.4592 27.405 12.7192 28.325L10.8892 30.605C10.4692 31.135 10.8392 31.915 11.5192 31.915H29.6992C30.2792 31.915 30.7592 31.445 30.7592 30.855V27.925C30.7592 27.345 30.2892 26.865 29.6992 26.865H29.7092Z",
    fill: "url(#g)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 27.25,
    y1: 8.08502,
    x2: 12.25,
    y2: 31.2501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0576923,
    stopColor: "#00BFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557692,
    stopColor: "#FF9101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.600962,
    stopColor: "#FF9101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.971154,
    stopColor: "#00DB95"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngardeLogo);
export default __webpack_public_path__ + "static/media/engarde-logo.5f7ca180b49f2dc71eb68d6e9efc0cb1.svg";
export { ForwardRef as ReactComponent };